import DrawDown from "./DrawDown.jsx";

export default DrawDown;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/drawDown/index.js